/**
 * slash-app の instructor-announcements API ヘルパ。
 *
 * 会員向け一斉送信 (slashAppBroadcasts / チャット吹き出し配信) とは別系統で、
 * インストラクター向けの「タイトル + 本文」お知らせを扱う。配信の実体は
 * slash-app 側で alerts テーブルへファンアウトされ、お知らせタブに並ぶ。
 * レスポンス JSON はそのまま返す (フィールド名は slash-app 仕様)。
 */
import { slashAppJson } from "./slashAppClient";

export const slashAppAnnouncements = {
  /**
   * GET /api/v1/instructor-announcements/
   * @param {{page?:number, status?:""|"sent"|"draft"}} opts
   */
  list({ page = 1, status = "" } = {}) {
    const params = new URLSearchParams();
    params.set("page", String(page));
    if (status) params.set("status", status);
    return slashAppJson(
      `/api/v1/instructor-announcements/?${params.toString()}`
    );
  },

  /**
   * POST /api/v1/instructor-announcements/
   * @param {{
   *   title: string,
   *   body: string,
   *   target_type: "all_instructors" | "custom",
   *   target_instructors?: number[],
   *   is_draft?: boolean,
   * }} payload
   */
  create(payload) {
    return slashAppJson(`/api/v1/instructor-announcements/`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },

  /** GET /api/v1/instructor-announcements/<id>/ */
  detail(id) {
    return slashAppJson(`/api/v1/instructor-announcements/${id}/`);
  },

  /** PATCH /api/v1/instructor-announcements/<id>/ — 下書きの内容を更新 (送信済みは 400)。 */
  update(id, payload) {
    return slashAppJson(`/api/v1/instructor-announcements/${id}/`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  },

  /** POST /api/v1/instructor-announcements/<id>/send/ — 下書きを送信。 */
  send(id) {
    return slashAppJson(`/api/v1/instructor-announcements/${id}/send/`, {
      method: "POST",
    });
  },

  /** DELETE /api/v1/instructor-announcements/<id>/ — 未送信のみ可 (送信済みは 400)。 */
  remove(id) {
    return slashAppJson(`/api/v1/instructor-announcements/${id}/`, {
      method: "DELETE",
    });
  },

  /** GET /api/v1/instructor-announcements/<id>/stats/ */
  stats(id) {
    return slashAppJson(`/api/v1/instructor-announcements/${id}/stats/`);
  },

  /**
   * GET /api/auth/instructors/  (インストラクター選択ピッカー用)
   *
   * impersonation の InstructorSwitch と同一エンドポイント。返り値の
   * ``results`` の ``id`` は LegacyInstructor.id なので、そのまま
   * target_instructors に渡せる。
   */
  listInstructors() {
    return slashAppJson(`/api/auth/instructors/`);
  },
};
